import { Check, Copy, TriangleAlert } from 'lucide-react';
import { Button } from '@sara/ui/components/button';
import { useCopyToClipboard } from '../../../../hooks/useCopyToClipboard';

interface ApiKeySecretRevealProps {
  secret: string;
  onDone: () => void;
}

export function ApiKeySecretReveal({ secret, onDone }: ApiKeySecretRevealProps) {
  const { copied, copy } = useCopyToClipboard();

  return (
    <div className="space-y-5">
      <div className="flex gap-3 rounded-xl border border-amber-500/30 bg-amber-500/8 p-3.5 text-sm text-amber-900 dark:text-amber-200">
        <TriangleAlert className="mt-0.5 h-4 w-4 shrink-0" strokeWidth={1.6} />
        <div>
          <p className="font-medium">Save this key now.</p>
          <p className="mt-0.5 text-amber-800/90 dark:text-amber-200/80">
            This is the only time you&rsquo;ll see it. If you lose it, revoke it and create a new
            one.
          </p>
        </div>
      </div>

      <div className="space-y-2">
        <p className="text-[11px] font-medium uppercase tracking-[0.06em] text-muted-foreground/80">
          API key
        </p>
        <div className="flex items-stretch gap-2">
          <code className="flex-1 overflow-x-auto rounded-xl border border-border/70 bg-secondary/60 px-3.5 py-2.5 font-mono text-[12.5px] text-foreground/90">
            {secret}
          </code>
          <Button
            type="button"
            variant="ghost"
            size="icon"
            className="shrink-0 self-stretch rounded-xl border border-border/70 bg-secondary/40 text-muted-foreground hover:bg-secondary hover:text-foreground"
            onClick={() => copy(secret)}
            aria-label={copied ? 'Copied' : 'Copy to clipboard'}
          >
            {copied ? (
              <Check className="h-4 w-4 text-primary" strokeWidth={1.6} />
            ) : (
              <Copy className="h-4 w-4" strokeWidth={1.6} />
            )}
          </Button>
        </div>
      </div>

      <div className="flex justify-end">
        <Button variant="tinted" shape="pill" size="sm" className="gap-1.5" onClick={onDone}>
          Done
        </Button>
      </div>
    </div>
  );
}
